import classNames from 'classnames';

import s from './styles.module.scss';

import type { FC, ReactNode } from 'react';

const linkNumberQuestionTextEng =
  'Have you been experiencing any issues with your device?';
const linkNumberQuestionTextEsp =
  'Ha tenido algún problema con su dispositivo?';
const shortNumber = '90105';
const phoneNumber = '1-888-407-4108';

interface IFormBlockProps {
  children?: ReactNode;
  title: string;
  divider?: boolean;
  required?: boolean;
  description: string | null;
  error?: string;
  showShadow?: boolean;
}

export const FormBlock: FC<IFormBlockProps> = ({
  children,
  title,
  divider = true,
  required,
  description,
  error,
  showShadow,
}) => {
  const linkedDescription =
    title === linkNumberQuestionTextEng || title === linkNumberQuestionTextEsp;

  const desc =
    linkedDescription && description && showShadow
      ? description
          .replace(
            shortNumber,
            `<a href="sms:${shortNumber}">${shortNumber}</a>`,
          )
          .replace(
            phoneNumber,
            `<a href="tel:${phoneNumber}">${phoneNumber}</a>`,
          )
      : description;

  const modifiedTitle = title.replace(
    phoneNumber,
    `<a href="tel:${phoneNumber}">${phoneNumber}</a>`,
  );

  return (
    <div>
      <div
        className={classNames(s.wrapper, {
          [s.error]: !!error,
          [s.shadow]: showShadow,
        })}
      >
        <div className={s.header}>
          <div className={s.title}>
            <h5 dangerouslySetInnerHTML={{ __html: modifiedTitle }} />
            {required && <span>*</span>}
          </div>
          {desc && (
            <p
              className={s.description}
              dangerouslySetInnerHTML={{ __html: desc }}
            />
          )}
        </div>
        {divider && <div className={s.divider} />}
        {children && <div className={s.body}>{children}</div>}
      </div>
      {error && <p className={s.errorText}>{error}</p>}
    </div>
  );
};
